import { render, staticRenderFns } from "./serviceConfirmation.vue?vue&type=template&id=2d63e8d8&scoped=true&"
import script from "./serviceConfirmation.vue?vue&type=script&lang=js&"
export * from "./serviceConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./serviceConfirmation.vue?vue&type=style&index=0&id=2d63e8d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d63e8d8",
  null
  
)

export default component.exports